import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PlmService {
  private readonly base = `${environment.BASE_URL}plm`;

  constructor(private http: HttpClient) {}

  private params(obj?: Record<string, unknown>): { params?: HttpParams } {
    if (!obj) return {};
    let p = new HttpParams();
    Object.keys(obj).forEach((k) => {
      const v = obj[k];
      if (v !== null && v !== undefined && v !== '') p = p.set(k, String(v));
    });
    return { params: p };
  }

  health() {
    return this.http.get(`${this.base}/health`);
  }

  listWorkLocations(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/work-locations`, this.params(q));
  }
  createWorkLocation(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/work-locations`, body);
  }
  seedFromRoadProject(project_id: number): Observable<any> {
    return this.http.post(`${this.base}/work-locations/seed-from-road-project`, { project_id });
  }

  pavementCatalog(): Observable<any> {
    return this.http.get(`${this.base}/pavement/catalog`);
  }
  listPavementWork(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/pavement/work`, this.params(q));
  }
  createPavementWork(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/pavement/work`, body);
  }
  updatePavementWork(id: number, body: Record<string, unknown>): Observable<any> {
    return this.http.put(`${this.base}/pavement/work/${id}`, body);
  }

  listFurniture(kind: string, q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/furniture/${kind}`, this.params(q));
  }
  createFurniture(kind: string, body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/furniture/${kind}`, body);
  }
  updateFurniture(kind: string, id: number, body: Record<string, unknown>): Observable<any> {
    return this.http.put(`${this.base}/furniture/${kind}/${id}`, body);
  }

  listResourceMap(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/resource-map`, this.params(q));
  }
  createResourceMap(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/resource-map`, body);
  }
  listTools(): Observable<any> {
    return this.http.get(`${this.base}/tools`);
  }
  createTool(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/tools`, body);
  }
  listToolIssues(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/tool-issues`, this.params(q));
  }
  createToolIssue(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/tool-issues`, body);
  }
  listConsumables(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/consumable-issues`, this.params(q));
  }
  createConsumable(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/consumable-issues`, body);
  }
  listContractors(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/contractors`, this.params(q));
  }
  createContractor(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/contractors`, body);
  }

  listDailyProgress(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/daily-progress`, this.params(q));
  }
  createDailyProgress(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/daily-progress`, body);
  }
  listMedia(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/media`, this.params(q));
  }
  createMedia(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/media`, body);
  }

  listAcceptance(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/acceptance`, this.params(q));
  }
  createAcceptance(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/acceptance`, body);
  }
  listWcc(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/wcc`, this.params(q));
  }
  createWcc(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/wcc`, body);
  }
  issueWcc(id: number): Observable<any> {
    return this.http.post(`${this.base}/wcc/${id}/issue`, {});
  }
  listInvoiceLinks(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/invoice-links`, this.params(q));
  }
  createInvoiceLink(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/invoice-links`, body);
  }
  listHandover(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/handover`, this.params(q));
  }
  createHandover(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/handover`, body);
  }
  listOm(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/om-tickets`, this.params(q));
  }
  createOm(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/om-tickets`, body);
  }
  updateOm(id: number, body: Record<string, unknown>): Observable<any> {
    return this.http.put(`${this.base}/om-tickets/${id}`, body);
  }

  listGps(): Observable<any> {
    return this.http.get(`${this.base}/gps`);
  }
  ingestGps(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/gps`, body);
  }
  listGeofences(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/geofences`, this.params(q));
  }
  createGeofence(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/geofences`, body);
  }
  listEscalation(): Observable<any> {
    return this.http.get(`${this.base}/escalation`);
  }
  createEscalation(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/escalation`, body);
  }
  evaluateEscalation(): Observable<any> {
    return this.http.post(`${this.base}/escalation/evaluate`, {});
  }
  listReports(q?: Record<string, unknown>): Observable<any> {
    return this.http.get(`${this.base}/reports`, this.params(q));
  }
  createReport(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/reports`, body);
  }
  releaseReport(id: number): Observable<any> {
    return this.http.post(`${this.base}/reports/${id}/release`, {});
  }
  listBackup(): Observable<any> {
    return this.http.get(`${this.base}/backup-jobs`);
  }
  createBackup(body: Record<string, unknown>): Observable<any> {
    return this.http.post(`${this.base}/backup-jobs`, body);
  }
  runBackup(id: number): Observable<any> {
    return this.http.post(`${this.base}/backup-jobs/${id}/run`, {});
  }
}
